export class AccessibilityMessages {
  public access = 'accessibilite.access';
  public address = 'accessibilite.address';
  public aife = 'accessibilite.aife';
  public audit = 'accessibilite.audit';
  public audit2 = 'accessibilite.audit2';
  public contact = 'accessibilite.contact';
  public defender = 'accessibilite.defender';
  public delegate = 'accessibilite.delegate';
  public delegateUrl = 'accessibilite.delegate_url';
  public form = 'accessibilite.form';
  public formUrl = 'accessibilite.form_url';
  public generalSecretary = 'accessibilite.general_secretary';
  public law = 'accessibilite.law';
  public means = 'accessibilite.means';
  public ministryOfEconomy = 'accessibilite.ministry_of_economy';
  public notice = 'accessibilite.notice';
  public question = 'accessibilite.question';
  public street = 'accessibilite.street';
  public url = 'accessibilite.url';
  public zipCode = 'accessibilite.zip_code';
  public realisation = 'accessibilite.realisation';
  public agency = 'accessibilite.agency';
  public bercy = 'accessibilite.bercy';
  public cedex = 'accessibilite.cedex';
  constructor() {
  }
}
